export default [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/];
